import Typography from "components/Typography";

type CollapsedChartProps = {
  label: string;
  onButtonClick: () => void;
};
const CollapsedChart = ({ label, onButtonClick }: CollapsedChartProps) => {
  return (
    <div className="flex items-center mt-4 pr-4">
      <div className="w-full h-6 flex items-center justify-end text-white text-center px-6 bg-black">
        <Typography
          htmlTag="p"
          type="pTinny"
          color="inherit"
          weight="bold"
          align="right"
        >
          {label}
        </Typography>
      </div>
      <div className="w-40 pl-4 flex justify-end">
        <button
          onClick={onButtonClick}
          className="w-8 h-8 rounded-full border bg-[#EFF1F3] flex items-center justify-center"
        >
          <img
            src="/icons/chart-icon.svg"
            alt="Show Encounter"
            height={20}
            width={20}
            className=""
          />
        </button>
      </div>
    </div>
  );
};

export default CollapsedChart;
